import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ComponentsModule } from '@components/components.module';
import { DRAWER_DATA } from 'src/app/ui/drawer/drawer-data.token';

@Component({
	selector: 'app-request-document-preview',
	templateUrl: './request-document-preview.component.html',
	imports: [CommonModule, ComponentsModule],
})
export class RequestDocumentPreviewComponent {
	data = inject(DRAWER_DATA);
}
